import { createMuiTheme } from '@material-ui/core';
import { orange, blue } from '@material-ui/core/colors';

export const theme = createMuiTheme({
  typography: {
    fontFamily: 'Montserrat, Arial',
    h1: {
      fontSize: '22px',
      fontWeight: '500'
    },
    h2: {
      fontSize: '16px',
      fontWeight: '500'
    },
    h3: {
      fontSize: '16px',
      fontWeight: '500'
    }
  },
  palette: {
    primary: {
      main: blue[900]
    },
    secondary: {
      main: orange[500]
    }
  }
});
